var path = '/user/directives/cvapi-usage-bar.html';
var html = "<header class=section-heading ng-if=usage> Your day so far </header> <div class=cvapi-usage ng-if=usage> <div class=cvapi-usage-label ng-if=!usageError> <span data-test-id=accounts_vision_api_current_usage>{{usage}} </span> image calls </div> <div class=cvapi-usage-label ng-if=usageError> Unable to fetch usage information right now. </div> <md-progress-linear md-mode=determinate value={{percentage}}></md-progress-linear> <div class=cvapi-usage-range> <span class=cvapi-usage-start data-test-id=accounts_vision_api_quota_start> 0 </span> <span class=cvapi-usage-end data-test-id=accounts_vision_api_quota_end> {{limit}} </span> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./user/directives/cvapi-usage-bar.html
// module id = 119
// module chunks = 0